// extracted by mini-css-extract-plugin
export default {"l_Cross_main":"Cross_l_Cross_main__f-wyo"};